import React from "react";
import "./Group296.css";

function Group296() {
  return (
    <div className="group-29-2">
      <div className="flex-col-21">
        <img className="rectangle-4" src="/img/rectangle-87@2x.png" />
        <img className="rectangle-6" src="/img/rectangle-91@2x.png" />
        <img className="rectangle-6" src="/img/rectangle-87@2x.png" />
      </div>
      <div className="flex-col-22">
        <img className="rectangle-4" src="/img/rectangle-92@2x.png" />
        <img className="rectangle-6" src="/img/rectangle-89@2x.png" />
        <img className="rectangle-6" src="/img/rectangle-92@2x.png" />
      </div>
      <div className="flex-col-22">
        <img className="rectangle-4" src="/img/rectangle-88@2x.png" />
        <img className="rectangle-6" src="/img/rectangle-90@2x.png" />
        <img className="rectangle-6" src="/img/rectangle-88@2x.png" />
      </div>
    </div>
  );
}

export default Group296;
